import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles()(() => ({
  hintText: { color: 'rgba(0, 0, 0, 0.54)' },
}));

// COMPONENT
function HintText({ className, children, ...rest }) {
  const { classes, cx } = useStyles();
  return (
    <Typography className={className ? cx(className, classes.hintText) : classes.hintText} {...rest}>
      {children}
    </Typography>
  );
}

export default HintText;
